import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "./ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "./ui/dialog";
import { Share2, Copy, Check, Download } from "lucide-react";
import { toast } from "sonner";

export const ShareProfileButton = ({ url, title = "Partager le profil", label, className = "", variant = "outline" }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success("Lien copié !");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Impossible de copier"); }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url: shareUrl }); } catch { /* cancelled */ }
    } else { copyLink(); }
  };

  const downloadQR = () => {
    const canvas = document.getElementById("share-qr-canvas");
    if (!canvas) return;
    const link = document.createElement("a");
    link.download = "arcanapp-qr.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        variant={variant}
        className={`border-[#333] text-[#B0B0B0] hover:text-white hover:border-[#FF6B35] ${className}`}
        data-testid="share-profile-btn"
      >
        <Share2 className="w-4 h-4 sm:mr-2" />
        <span className={label ? "" : "hidden sm:inline"}>{label || "Partager"}</span>
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#1a1a1a] border-[#333] text-white max-w-sm">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription className="text-[#888]">Scannez le QR code ou partagez le lien</DialogDescription>
          </DialogHeader>
          <div className="flex flex-col items-center gap-4">
            <div className="bg-white p-3 rounded-xl" data-testid="share-qr-wrapper">
              <QRCodeCanvas id="share-qr-canvas" value={shareUrl} size={200} level="M" includeMargin={false} fgColor="#0a0a0a" bgColor="#ffffff" />
            </div>
            <div className="w-full flex items-center gap-2 bg-[#0a0a0a] border border-[#333] rounded-lg px-3 py-2">
              <span className="text-[#B0B0B0] text-xs truncate flex-1" data-testid="share-url-text">{shareUrl}</span>
              <button onClick={copyLink} className="shrink-0 text-[#FF6B35] hover:text-[#E55A25]" data-testid="share-copy-btn">
                {copied ? <Check className="w-4 h-4 text-green-400" /> : <Copy className="w-4 h-4" />}
              </button>
            </div>
            <div className="w-full grid grid-cols-2 gap-2">
              <Button onClick={downloadQR} variant="outline" className="border-[#333] text-[#B0B0B0] hover:text-white gap-1.5" data-testid="share-download-qr">
                <Download className="w-4 h-4" />QR code
              </Button>
              <Button onClick={nativeShare} className="bg-[#FF6B35] hover:bg-[#E55A25] gap-1.5" data-testid="share-native-btn">
                <Share2 className="w-4 h-4" />Partager
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ShareProfileButton;
